export default __webpack_public_path__ + "static/media/Snd_TryP.4a0b38bb.mp3";